import { useLocalSearchParams } from "expo-router";
import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import LoginPage from "$src/core/pages/LoginPage";

type Params = {
  redirect?: string;
};

const Route: React.FC = () => {
  const { redirect } = useLocalSearchParams<Params>();

  return (
    <PageLayout>
      <LoginPage redirect={redirect} />
    </PageLayout>
  );
};

export default Route;
